// extracted by mini-css-extract-plugin
export var aboveInput = "_k4-0";
export var actionButton = "_k4-5";
export var actionButtonContainer = "_k4-1";
export var actionIcon = "_k4-6";
export var aiInfoContainer = "_k4-2";
export var attachmentWrapper = "_k4-7";
export var bold = "_k4-3";
export var checkIcon = "_k4-8";
export var clickingRecipientBar = "_k4-11";
export var commentThreadSwitch = "_k4-a";
export var draftImage = "_k4-b";
export var draftImageContainer = "_k4-c";
export var draftImages = "_k4-e";
export var editButton = "_k4-g";
export var editor = "_k4-f";
export var editorContainer = "_k4-y";
export var editorErrorTooltipWrapper = "_k4-9";
export var headerDivider = "_k4-h";
export var icon = "_k4-i";
export var info = "_k4-j";
export var internal = "_k4-n";
export var internalDivider = "_k4-k";
export var internalMessage = "_k4-l";
export var messageInputCard = "_k4-m";
export var messageInputForm = "_k4-o";
export var messageInputFormInternal = "_k4-p";
export var options = "_k4-q";
export var publicMessageCustomer = "_k4-s";
export var publicMessageMerchant = "_k4-r";
export var removeImageButton = "_k4-d";
export var replyButtons = "_k4-t";
export var showSignatureButton = "_k4-u";
export var spinner = "_k4-v";
export var verticalButtonDivider = "_k4-4";
export var visibilitySelector = "_k4-w";
export var warning = "_k4-x";
export var wrappingText = "_k4-z";
export var writingInternalNoteTopBorder = "_k4-10";